import { createFileRoute } from "@tanstack/react-router";
import GaushalaPage from "@project/user/pages/programs/gaushala";
import careImg from "@project/assets/home-care.webp";

export const Route = createFileRoute("/_user/_programs/gaushala")({
  head: () => ({
    meta: [
      { title: "Vrindavan Gir Gaushala — Jivandhara" },
      {
        name: "description",
        content:
          "Vrindavan Gir Gaushala provides lifelong shelter, fresh green fodder, medical care, and sanctuary to Gir cows, calves, and bulls rooted in Jeev Daya.",
      },
      { property: "og:title", content: "Vrindavan Gir Gaushala — Jivandhara" },
      { property: "og:image", content: careImg },
    ],
  }),
  component: GaushalaPage,
});
